export const VIDEO_EDITOR_STATUS = {
  notStarted: 'not_started',
  pending: 'pending',
  processing: 'processing',
  finished: 'finished',
  errored: 'errored'
};

export const VIDEO_EDITOR_CLIP_MODE = {
  clip: 'clip',
  cut: 'cut',
  merge: 'merge'
};

export const VIDEO_EDITOR_INITIAL_CLIP_DURATION_RATIO = 0.05;
export const VIDEO_EDITOR_KEYBOARD_NUDGE_SECONDS = 0.5;
export const VIDEO_EDITOR_PREVIEW_FRAME_MAX_DIMENSION = 200;
export const VIDEO_EDITOR_CUSTOM_FRAME_EDITOR_EXPORT_TYPE = 'jpeg';
export const VIDEO_EDITOR_CUSTOM_FRAME_SNAPSHOT_EXPORT_TYPE = 'jpeg';
export const VIDEO_EDITOR_TITLE_FRAME_EXPORT_TYPE = 'png';
export const VIDEO_EDITOR_TITLE_FRAME_EXTENSION = 'png';
export const VIDEO_EDITOR_TITLE_FRAME_EXPORT_ERROR = 'TITLE_FRAME_EXPORT_FAILED';
export const VIDEO_EDITOR_CLIP_TOO_SHORT_ERROR = 'CLIP_TOO_SHORT';
export const VIDEO_EDITOR_CLIP_OUT_OF_BOUNDS_ERROR = 'CLIP_OUT_OF_BOUNDS';
export const VIDEO_EDITOR_CUSTOM_FRAME_EDITOR_MODAL_ID = 'video-custom-frame-editor';

export const VIDEO_EDITOR_CUSTOM_FRAME_DESIGN_PROJECT_TYPES = 'video_frame';

export const VIDEO_EDITOR_CUSTOM_FRAME_DESIGN_PROJECT_TEMPLATE_TYPES = {
  portrait: 'video_frame_portrait',
  landscape: 'video_frame_landscape'
};

export const VIDEO_TITLE_FRAME_DEFAULT_DIMENSIONS = {
  width: 1920,
  height: 1080
};
export const VIDEO_TITLE_FRAME_DEFAULT_DURATION = 4;

export const VIDEO_EDITOR_MIN_CLIP_DURATION_SECONDS = 1;

// The backend `file_name` column allows at most 255 characters, and the export step appends
// ".mp4" (4 characters) to the clip name, so the name itself must leave room for that.
export const VIDEO_EDITOR_CLIP_NAME_MAX_LENGTH = 251;

export const VIDEO_MERGE_MAX_DURATION_MS = 30 * 60 * 1000; // 30 minutes

export const NOTIFICATION_OUTPUT_TYPES = {
  foreverFile: 'ForeverFile',
  foreverContainer: 'ForeverContainer'
};
